import type { MapTile } from '../../engine/world/types';
import type { BiomeMap, BiomeType, HeightMap, WorldGeneratorConfig } from './types';

export class BiomeGenerator {
  constructor(private readonly config: WorldGeneratorConfig) {}

  generateBiomeMap(heightMap: HeightMap, tiles: readonly MapTile[]): BiomeMap {
    const tileLookup = new Map(tiles.map((tile) => [`${tile.x}:${tile.y}`, tile]));
    return {
      width: this.config.width,
      height: this.config.height,
      tiles: Array.from({ length: this.config.width * this.config.height }, (_, index) => {
        const x = index % this.config.width;
        const y = Math.floor(index / this.config.width);
        const tile = tileLookup.get(`${x}:${y}`);
        return {
          x,
          y,
          biome: this.resolveBiome(heightMap.values[index] ?? 0.45, tile),
        };
      }),
    };
  }

  private resolveBiome(height: number, tile?: MapTile): BiomeType {
    if (tile?.type === 'water' || tile?.type === 'shore') return 'riverland';
    if (tile?.type === 'mountain' || height >= 0.72) return 'mountain';
    if (tile?.type === 'forest') return 'forest';
    if (tile?.type === 'field') return 'farmland';
    if (tile?.type === 'road' || tile?.type === 'workyard') return 'settlement';
    if (height <= 0.25) return 'coast';
    if (height >= 0.58) return 'forest';
    return 'meadow';
  }
}
